import { AlmanacConfig } from "protos/almanac/almanac";
import { localeCompare } from "portal/utils/strings";
import { portalApi } from "portal/state/portalApi";
import { useMemo } from "react";
import { useQueryPopups } from "portal/utils/hooks/useApiPopups";
import { useTranslation } from "react-i18next";

/**
 * The Carbon default almanac: the first global almanac, using the same
 * name ordering as `useAlmanacOptions`' `defaultAlmanacId`. Shares the
 * `listGlobalAlmanacs` RTK cache with that hook.
 */
export const useCarbonDefaultAlmanac = (): {
  almanac: AlmanacConfig | undefined;
  isLoading: boolean;
} => {
  const { i18n } = useTranslation();
  const { data: globalAlmanacs, isLoading } = useQueryPopups(
    portalApi.endpoints.listGlobalAlmanacs.useQuery({}),
    { errorVariant: "warning" }
  );

  const almanac = useMemo(() => {
    const sorted = [...(globalAlmanacs ?? [])].sort((a, b) =>
      localeCompare(a.name, b.name, i18n.language)
    );
    return sorted[0];
  }, [globalAlmanacs, i18n.language]);

  return { almanac, isLoading };
};
